var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 130,
    viewBox: "0 0 105 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 0.833313L0 24.1666V59.1666C0 91.5416 22.4 121.817 52.5 129.167C82.6 121.817 105 91.5416 105 59.1666V24.1666L52.5 0.833313ZM52.5 23.5833C55.9612 23.5833 59.3446 24.6097 62.2225 26.5326C65.1003 28.4555 67.3434 31.1886 68.6679 34.3864C69.9924 37.5841 70.339 41.1027 69.6637 44.4974C68.9885 47.8921 67.3218 51.0103 64.8744 53.4577C62.427 55.9051 59.3088 57.5718 55.9141 58.2471C52.5194 58.9223 49.0007 58.5757 45.803 57.2512C42.6053 55.9267 39.8722 53.6836 37.9493 50.8058C36.0264 47.9279 35 44.5445 35 41.0833C35 36.442 36.8437 31.9908 40.1256 28.7089C43.4075 25.4271 47.8587 23.5833 52.5 23.5833ZM52.5 69.6666C64.1667 69.6666 87.5 76.025 87.5 87.6333C83.6688 93.409 78.4679 98.1468 72.3609 101.424C66.254 104.702 59.4308 106.417 52.5 106.417C45.5692 106.417 38.746 104.702 32.6391 101.424C26.5321 98.1468 21.3312 93.409 17.5 87.6333C17.5 76.025 40.8333 69.6666 52.5 69.6666Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.074393e4c7936259033ac08f797ffaef.svg";
export { ForwardRef as ReactComponent };